import script from "./LayoutVue.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutVue.vue?vue&type=script&setup=true&lang=js"

import "./LayoutVue.vue?vue&type=style&index=0&id=50eba71c&lang=scss"

const __exports__ = script;

export default __exports__